import { render, staticRenderFns } from "./Proveedor.vue?vue&type=template&id=1ebbe8d0&"
import script from "./Proveedor.vue?vue&type=script&lang=js&"
export * from "./Proveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports